import React from 'react';
import styles from './ProductOffers.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as ArrowUpIcon } from '../../images/icons/arrowUp.svg';
import { ReactComponent as ArrowDownIcon } from '../../images/icons/arrowDown.svg';

const ListSortingHeading = ({ activeShopsSortOrder, availableSortOptions, changeSortOrder }) => {
  return (
    <div className={classNames(styles.listSorting)} key="sort">
      <i></i>
      <div
        className={classNames(styles.sortByName, styles.sorting, {
          [styles.isActive]: activeShopsSortOrder.key === availableSortOptions.name.key,
        })}
        onClick={() => changeSortOrder(availableSortOptions.name)}
      >
        <FormattedMessage id="shop.sortBy.name" defaultMessage="Sort By name" />
        {activeShopsSortOrder.key === availableSortOptions.name.key &&
          (activeShopsSortOrder.direction === 'asc' ? <ArrowUpIcon /> : <ArrowDownIcon />)}
      </div>
      {/* <div className={classNames(styles.sortingTrustmark, styles.sorting, styles.disabled)}>
        <FormattedMessage id="shop.sortBy.trustmark" defaultMessage="Sort By trustmark" />
      </div> */}
      <div className={classNames(styles.sortingDelivery, styles.sorting, styles.disabled)}>
        <FormattedMessage id="shop.sortBy.delivery" defaultMessage="Sort By delivery" />
      </div>
      <div
        className={classNames(styles.priceTitle, styles.sorting, {
          [styles.isActive]: activeShopsSortOrder.key === availableSortOptions.price.key,
        })}
        onClick={() => changeSortOrder(availableSortOptions.price)}
      >
        <FormattedMessage id="shop.sortBy.price" defaultMessage="Sort By Price" />
        {activeShopsSortOrder.key === availableSortOptions.price.key &&
          (activeShopsSortOrder.direction === 'asc' ? <ArrowUpIcon /> : <ArrowDownIcon />)}
      </div>
      <i></i>
    </div>
  );
};

export default ListSortingHeading;
